import { __awaiter, __decorate } from "tslib";
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../../../services/http-client.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../../services/auth.service';
import { SpinnerService } from '../../../spinner/spinner.service';
import { WebClientService } from '../../../../services/webclient-settings.service';
import { WebsiteThemeService } from '../../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilityService } from '../../../../services/utility.service';
import { LimitExceededModalComponent } from "../../../limit-exceeded-modal/limit-exceeded-modal.component";
import { ComponentService } from "../../../../services/component.service";
import { DepositOriginService } from '../../../../services/deposit-origin.service';
import { isDepositOriginCode } from '../../../../services/deposit-origin';
import { CheckProtocolModalComponent } from "../../../check-protocol-modal/check-protocol-modal.component";
/**
 * Sell Component
 */
let SellComponent = class SellComponent {
    constructor(httpClient, route, router, auth, spinner, webSettingsService, sanitizer, themeService, utility, compService, depositOriginService) {
        this.httpClient = httpClient;
        this.route = route;
        this.router = router;
        this.auth = auth;
        this.spinner = spinner;
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.utility = utility;
        this.compService = compService;
        this.depositOriginService = depositOriginService;
        this.sellData = {};
        this.draftData = {};
        this.status = 'registred_user';
        this.userData = {};
        this.bankAccounts = [];
        this.saveAddress = '';
        this.orderMessage = '';
        this.limitValue = '';
        this.textColor = '';
        this.errorColor = '';
        this.successColor = '';
        this.mainColor = '';
        this.linkColor = '';
        this.secondColor = '';
        this.inputTextColor = '';
        this.accentColor = '';
        this.orderType = 'sell';
        this.meanOfPayment = 'bank_slip';
        this.orderState = '';
        this.sentEmailMessage = false;
        this.confirmationMessage = '';
        this.confirmationMessageError = '';
        this.clicked = false;
        this.errorInForm = false;
        this.borderRadiusLarger = '';
        this.targetUrl = '';
        this.ecurrencyChains = [];
        this.someoneElsesAddressError = false;
        this.feesAndLimitsLoaded = false;
        this.orderAlreadyCreatedError = false;
        this.priceLoaded = false;
        this.priceNotLoadedMessage = false;
        this.userValidated = false;
        this.isUser = false;
        this.userData = JSON.parse(localStorage.getItem('user'));
        this.themeService.getTheme().subscribe((data) => {
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        this.sellData = this.userData;
        this.sellData.address = this.userData.city;
        this.sellData.mean_of_payment = this.userData.mean_bank_slip_sell;
        this.userType = this.userData.user_type_id.type;
        this.status = this.userType + '_user';
        this.isIndividual = this.userData.is_company_user ? 0 : 1;
        this.userValidated = this.userData.validated;
        this.sub = this.route.params.subscribe((params) => {
            this.nameOfCurrency = params['id'];
        });
        this.httpClient.get('user/isorderallowed?cryptocurrency=' + this.nameOfCurrency + '&txtype=sell&mop=' + this.userData.mean_bank_slip_sell).subscribe((result) => {
            this.orderMessage = result + '';
        });
        this.httpClient.get('market/order/get_ecurrency_chains?' + 'currency=' + this.nameOfCurrency + '&order_type=' + this.orderType + '&mean_of_payment=' + this.meanOfPayment).subscribe((result) => {
            this.ecurrencyChains = result['chains'];
            this.numOfChains = result['num_of_chains'];
            if (this.ecurrencyChains.length === 1) {
                this.httpClient.get('market/feesandlimits?ecurrency=' + this.nameOfCurrency + '&mop=' + this.sellData.mean_of_payment + '&user_type=' + this.userType + '&order_type=sell' + '&is_individual=' + this.isIndividual + '&chain=' + this.ecurrencyChains[0]['chain']['name']).subscribe((data) => {
                    const allData = Object.values(data);
                    if (allData.length > 0 || allData['sell'] !== undefined) {
                        const fullSellData = data['sell'];
                        if (this.nameOfCurrency in fullSellData) {
                            const currentData = fullSellData[this.nameOfCurrency][this.sellData.mean_of_payment][this.userType];
                            this.provision = parseFloat(currentData.fee);
                            this.minAmount = parseFloat(currentData.min_amount);
                            this.maxAmount = parseFloat(currentData.max_amount);
                            this.fixedFee = parseFloat(currentData.fixed_fee);
                            this.minFee = parseFloat(currentData.min_fee);
                        }
                        else {
                            this.provision = null;
                        }
                    }
                    this.feesAndLimitsLoaded = true;
                });
            }
            else {
                this.feesAndLimitsLoaded = true;
            }
        });
        this.httpClient.get('user/getbankaccounts').subscribe((result) => {
            this.bankAccounts = result;
        });
        this.targetUrl = this.router.url;
        if (this.targetUrl.startsWith('/sell')) {
            if (this.userData.risk_level === 'High') {
                this.httpClient.get('market/order/questionnaireFilled?risk_level=' + this.userData.risk_level).subscribe((data) => {
                    if (!data['isQuestionnaireFilled']) {
                        localStorage.setItem('riskLevel', this.userData.risk_level);
                        localStorage.setItem("questionnaireSubmitted", "false");
                        this.router.navigateByUrl('/questionnaire');
                    }
                });
            }
        }
        this.getPrice();
        setTimeout(() => {
            this.priceNotLoadedMessage = true;
        }, 3000);
    }
    ngOnInit() {
        var scrollStep = -window.scrollY / (100 / 15), scrollInterval = setInterval(function () {
            if (window.scrollY != 0) {
                window.scrollBy(0, scrollStep);
            }
            else
                clearInterval(scrollInterval);
        }, 15);
        this.spinner.stop();
    }
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.orderForm !== 'undefined') {
                this.orderForm.validateBankAccount(this.orderForm.getData().bank_account);
                this.orderForm.validateTotalAndAmount();
                const data = this.orderForm.getData();
                if (typeof this.provision === 'undefined') {
                    this.provision = data.provision;
                }
                yield this.orderForm.verifyDiscount();
                if (!data.ecurrencyChain)
                    this.orderForm.chainError = true;
                this.errorInForm = !this.orderForm.validateTotalAndAmount() || !this.orderForm.validateBankAccount(this.orderForm.getData().bank_account) || this.orderForm.couponError || this.orderForm.chainError || this.orderForm.someoneElsesAddresses.includes(data.bank_account);
                if (!this.errorInForm) {
                    this.sellData.cryptocurrency = this.nameOfCurrency;
                    this.sellData.mean_of_payment = this.meanOfPayment;
                    this.sellData.total = data.total;
                    this.sellData.amount = data.amount;
                    this.sellData.bank_account = data.bank_account;
                    this.sellData.discount_code = data.discount_code;
                    this.sellData.chain = data.ecurrencyChain['chain']['name'];
                    this.saveAddress = data.saveAddress;
                    this.whatLast = this.orderForm.whatLast;
                    this.someoneElsesAddressError = false;
                    if (this.ecurrencyChains.length > 1) {
                        this.maxAmount = data.maxAmount;
                        this.minAmount = data.minAmount;
                    }
                    if (this.sellData.amount <= this.maxAmount && this.sellData.amount >= this.minAmount && this.orderForm.validateBankAccount(this.sellData.bank_account)) {
                        if (this.whatLast === 'amount') {
                            delete this.sellData.total;
                        }
                        if (this.whatLast === 'total') {
                            delete this.sellData.amount;
                        }
                        if (this.orderForm.shouldSaveMethod()) {
                            this.sellData.remember = 1;
                            this.sellData.account_name = this.saveAddress;
                        }
                        if (this.ecurrencyChains.length > 1) {
                            this.compService.openModal(CheckProtocolModalComponent, {
                                selectedChain: data.ecurrencyChain,
                            }, (success) => {
                                this.createSellOrder();
                            }, (error) => {
                                this.clicked = false;
                            });
                        }
                        else {
                            this.createSellOrder();
                        }
                    }
                }
            }
        });
    }
    createSellOrder() {
        this.httpClient.post('market/order/draft/registred/sell', this.sellData)
            .subscribe((draftData) => {
            this.draftData = draftData;
            localStorage.setItem('draftData', JSON.stringify(this.draftData));
            localStorage.setItem('orderId', this.draftData.order_id);
            this.orderState = this.draftData.order_state;
            if (draftData['status'] === 'Čekanje na dokumentaciju') {
                this.httpClient.post('market/order/sendL2LimitInstructions', { order_id: this.draftData.order_id }).subscribe();
                this.router.navigateByUrl('/documentation/' + draftData['order_id']);
            }
            else {
                if (this.orderState === 'confirmed') {
                    this.router.navigateByUrl('/sell/confirm/' + this.draftData.order_id);
                }
                else if (this.orderState === 'unconfirmed') {
                    this.sentEmailMessage = true;
                }
            }
        }, (error) => {
            this.orderMessage = error.error['message'];
            if (this.orderMessage === 'ORDER_ALREADY_CREATED') {
                this.orderAlreadyCreatedError = true;
                setTimeout(() => {
                    this.clicked = false;
                    this.orderAlreadyCreatedError = false;
                }, 30000);
            }
            else {
                this.clicked = false;
            }
            if (this.orderMessage === 'BANK_ACCOUNT_USED_BY_ANOTHER_USER') {
                this.someoneElsesAddressError = true;
            }
            if (this.orderMessage === 'USER_WEEKLY_LIMIT_EXCEEDED') {
                this.httpClient.get('market/order/questionnaireValidated?order_type_name=' + this.orderType).subscribe((data) => {
                    if (!data['isQuestionnaireValidatedThisWeek']) {
                        localStorage.setItem('orderType', this.orderType);
                        localStorage.setItem('orderData', JSON.stringify(this.sellData));
                        localStorage.setItem("questionnaireSubmitted", "false");
                        localStorage.setItem("provision", JSON.stringify(this.provision));
                        this.router.navigateByUrl('/questionnaire');
                    }
                });
            }
            if (isDepositOriginCode(this.orderMessage)) {
                // the deposit trigger wants the statement or the proof of origin: its window over this page
                this.depositOriginService.openForCode(this.orderMessage);
            }
            if (this.orderMessage === 'USER_WEEKLY_LIMIT_LITE_EXCEEDED' || this.orderMessage === 'USER_MONTHLY_LIMIT_LITE_EXCEEDED' || this.orderMessage === 'USER_YEARLY_LIMIT_LITE_EXCEEDED') {
                this.compService.openModal(LimitExceededModalComponent);
            }
            if (this.orderMessage === "USER_DAILY_LIMIT_EXCEEDED" ||
                this.orderMessage === "USER_WEEKLY_LIMIT_EXCEEDED" ||
                this.orderMessage === "USER_WEEKLY_LIMIT_L2_EXCEEDED" ||
                this.orderMessage === "USER_MONTHLY_LIMIT_EXCEEDED") {
                this.limitValue = error.error['value'];
            }
        });
    }
    validateEmail(email) {
        const reg = /^([A-Za-z0-9_\-\.\+])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,15})$/;
        if (reg.test(email) === false) {
            return false;
        }
        return true;
    }
    send_email_again() {
        if (!this.utility.disabledFromTimer) {
            this.confirmationMessage = '';
            this.confirmationMessageError = '';
            this.utility.goDisableSendSmsButton();
            this.httpClient.post('market/order/draft/requestconfirm', { id: this.draftData.order_id }).subscribe((success) => {
                this.confirmationMessage = success['message'];
            }, (error) => {
                this.confirmationMessageError = error.error['message'];
                this.utility.resetTimer();
            });
        }
    }
    checkIfFormIsValid() {
        if (typeof this.orderForm !== 'undefined') {
            return !!((this.clicked && !this.errorInForm) || !this.orderForm.txData.amount || !this.orderForm.validTotalAndAmount
                || !this.orderForm.txData.bank_account || !this.orderForm.checkedIfBankAccountIsValid || !this.orderForm.validBankAccount || this.orderForm.couponError
                || this.orderForm.someoneElsesAddresses.includes(this.orderForm.txData.bank_account));
        }
        else {
            return true;
        }
    }
    showDefaultErrorMessage() {
        const errorMessages = [
            'INVALID_AMOUNT',
            'CURRENCY_ORDER_TYPE_DISABLED',
            'USER_TOO_MANY_ORDERS',
            'USER_DAILY_LIMIT_EXCEEDED',
            'USER_WEEKLY_LIMIT_EXCEEDED',
            'USER_MONTHLY_LIMIT_EXCEEDED',
            'PERSONAL_VERIFICATION_REQUIRED',
            'ORDER_ALREADY_CREATED',
            'ORDER_ALLOWED',
            'BANK_ACCOUNT_USED_BY_ANOTHER_USER',
            'USER_VERIFICATION_DOCUMENT_EXPIRED_OR_PENDING',
            'DEPOSIT_WEEKLY_LIMIT_EXCEEDED',
            'DEPOSIT_WEEKLY_LIMIT_L2_EXCEEDED',
            ''
        ];
        return !errorMessages.includes(this.orderMessage);
    }
    getPrice() {
        this.httpClient.get('market/price/' + this.nameOfCurrency).subscribe((data) => {
            this.priceLoaded = true;
            this.price = data;
        });
    }
};
SellComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ActivatedRoute },
    { type: Router },
    { type: AuthService },
    { type: SpinnerService },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: UtilityService },
    { type: ComponentService },
    { type: DepositOriginService }
];
__decorate([
    ViewChild('orderForm')
], SellComponent.prototype, "orderForm", void 0);
SellComponent = __decorate([
    Component({
        selector: 'ecd-sell-component',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./sell.component.html")).default
    })
], SellComponent);
export { SellComponent };
